import cn from 'classnames'
import { type ReactElement, type ReactNode } from 'react'

interface ValueProps {
  additionalClasses?: string
  children: ReactNode
}

export default function Value ({ additionalClasses, children }: ValueProps): ReactElement {
  return (
    <div className={cn('px-3 py-4 border-t border-r border-wpy-light-blue-700 w-full text-left', additionalClasses)}>
      {children}
    </div>
  )
}
